// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__d5GhI","footer":"ChangeClinic_footer__26mKj"};